import React from 'react';
import { Navigate } from 'react-router-dom';

const RequireAuth = ({ children, user, allowedRoles = [] }) => {
  if (!user || !user.token) {
    return <Navigate to="/login" replace />;
  }

  // Eğer allowedRoles belirtilmişse, kullanıcının rolü kontrol edilir
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Yetkisiz erişim - kullanıcıyı uygun sayfaya yönlendir
    if (user.role === 'AGENCY') {
      return <Navigate to="/agency" replace />;
    } else if (user.role === 'ADMIN') {
      return <Navigate to="/dashboard" replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default RequireAuth;
